<template>
<div class="chapter">
<div class="inner_page">
<section class="part" epub:type="part" id="part-001"><span epub:type="pagebreak" id="page_13" title="13"><div class="part_debut"></div><h1 class="part_n" epub:type="title"><span><img alt="Description à venir" class="imagelarge_intext" id="part1" src="images/part1.jpg"/></span></h1><h1 class="part_tit" epub:type="title"><span>The Growth of a<br/>Poet’s Mind</span></h1></span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p1.vue?387c0c90